// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";

import * as dep_1 from "./../google/protobuf/empty";
import * as dep_2 from "./user";

export enum TokenRight {
    UNDEFINED_TokenRight = 0,
    /**
     * user Tootela
     */
    INTERNAL = 1,
    ADMIN = 2,
    DEVELOPER = 3,
    ADVISER = 4,
    MENTOR = 5,
    MANAGER = 6,
    TRAINER = 7,
    INVOICE = 8,
    MARKETING = 9,
    /**
     * contact Tootela
     */
    TRAINEE = 50,
    /**
     * common rights
     */
    LOGIN_AS = 100,
}
export interface IToken {
    userId?: number;
    rights?: TokenRight[];
    email?: string;

}
export class Token implements IToken {

    userId?: number;
    rights?: TokenRight[];
    email?: string;

    constructor(data?: Partial<IToken>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MToken extends Message implements Token {

    constructor(data?: Partial<IToken>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("userId" in data && data.userId != undefined) this.userId = data.userId;
            if ("rights" in data && data.rights != undefined) this.rights = data.rights;
            if ("email" in data && data.email != undefined) this.email = data.email;
        }
    }

    get userId(): number {
        return Message.getField(this, 1) as number;
    }
    set userId(value: number) {
        Message.setField(this, 1, value);
    }

    get rights(): TokenRight[] {
        return Message.getField(this, 2) as TokenRight[];
    }
    set rights(value: TokenRight[]) {
        Message.setField(this, 2, value);
    }

    get email(): string {
        return Message.getField(this, 3) as string;
    }
    set email(value: string) {
        Message.setField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Token() : {} as Token;
        if (this.userId != undefined) data.userId = this.userId;
        if (this.rights?.length) data.rights = this.rights;
        if (this.email != undefined) data.email = this.email;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.userId !== undefined) writer.writeInt32(1, this.userId);
                if (this.rights !== undefined) writer.writeRepeatedEnum(2, this.rights);
                if (this.email !== undefined) writer.writeString(3, this.email);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IToken): Uint8Array {
        return (data instanceof Message ? (data as MToken) : new MToken(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MToken {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MToken();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.userId = reader.readInt32();
                    break;
            case 2:
                    message.rights = reader.readPackedEnum();
                    break;
            case 3:
                    message.email = reader.readString();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MToken {
        return MToken.deserializeBinaryFromReader(new MToken(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MToken, reader: BinaryReader) {
        return Object.assign(msg, MToken.deserialize(reader))
    };

}
export interface IAccount {
    id?: number;
    firstname?: string;
    lastname?: string;
    email?: string;
    phone?: string;
    cellphone?: string;
    address?: string;
    photo?: string;
    moodleSuspended?: boolean;
    color?: string;
    /**
     * mentor / adviser / assistant / ...
     */
    contacts?: dep_2.IUser[];

}
export class Account implements IAccount {

    id?: number;
    firstname?: string;
    lastname?: string;
    email?: string;
    phone?: string;
    cellphone?: string;
    address?: string;
    photo?: string;
    moodleSuspended?: boolean;
    color?: string;
    contacts?: dep_2.User[];

    constructor(data?: Partial<IAccount>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MAccount extends Message implements Account {

    constructor(data?: Partial<IAccount>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [10], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("firstname" in data && data.firstname != undefined) this.firstname = data.firstname;
            if ("lastname" in data && data.lastname != undefined) this.lastname = data.lastname;
            if ("email" in data && data.email != undefined) this.email = data.email;
            if ("phone" in data && data.phone != undefined) this.phone = data.phone;
            if ("cellphone" in data && data.cellphone != undefined) this.cellphone = data.cellphone;
            if ("address" in data && data.address != undefined) this.address = data.address;
            if ("photo" in data && data.photo != undefined) this.photo = data.photo;
            if ("moodleSuspended" in data && data.moodleSuspended != undefined) this.moodleSuspended = data.moodleSuspended;
            if ("color" in data && data.color != undefined) this.color = data.color;
            if ("contacts" in data && data.contacts != undefined) this.contacts = data.contacts.map(d => new dep_2.MUser(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get firstname(): string {
        return Message.getField(this, 2) as string;
    }
    set firstname(value: string) {
        Message.setField(this, 2, value);
    }

    get lastname(): string {
        return Message.getField(this, 3) as string;
    }
    set lastname(value: string) {
        Message.setField(this, 3, value);
    }

    get email(): string {
        return Message.getField(this, 4) as string;
    }
    set email(value: string) {
        Message.setField(this, 4, value);
    }

    get phone(): string {
        return Message.getField(this, 5) as string;
    }
    set phone(value: string) {
        Message.setField(this, 5, value);
    }

    get cellphone(): string {
        return Message.getField(this, 6) as string;
    }
    set cellphone(value: string) {
        Message.setField(this, 6, value);
    }

    get address(): string {
        return Message.getField(this, 7) as string;
    }
    set address(value: string) {
        Message.setField(this, 7, value);
    }

    get photo(): string {
        return Message.getField(this, 8) as string;
    }
    set photo(value: string) {
        Message.setField(this, 8, value);
    }

    get moodleSuspended(): boolean {
        return Message.getField(this, 9) as boolean;
    }
    set moodleSuspended(value: boolean) {
        Message.setField(this, 9, value);
    }

    get color(): string {
        return Message.getField(this, 11) as string;
    }
    set color(value: string) {
        Message.setField(this, 11, value);
    }

    get contacts(): dep_2.MUser[] {
        return Message.getRepeatedWrapperField(this, dep_2.MUser, 10);
    }
    set contacts(value: dep_2.MUser[]) {
        Message.setRepeatedWrapperField(this, 10, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Account() : {} as Account;
        if (this.id != undefined) data.id = this.id;
        if (this.firstname != undefined) data.firstname = this.firstname;
        if (this.lastname != undefined) data.lastname = this.lastname;
        if (this.email != undefined) data.email = this.email;
        if (this.phone != undefined) data.phone = this.phone;
        if (this.cellphone != undefined) data.cellphone = this.cellphone;
        if (this.address != undefined) data.address = this.address;
        if (this.photo != undefined) data.photo = this.photo;
        if (this.moodleSuspended != undefined) data.moodleSuspended = this.moodleSuspended;
        if (this.color != undefined) data.color = this.color;
        if (this.contacts.length) data.contacts = this.contacts.map(d => d.toObject(includeInstance));

        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.firstname !== undefined) writer.writeString(2, this.firstname);
                if (this.lastname !== undefined) writer.writeString(3, this.lastname);
                if (this.email !== undefined) writer.writeString(4, this.email);
                if (this.phone !== undefined) writer.writeString(5, this.phone);
                if (this.cellphone !== undefined) writer.writeString(6, this.cellphone);
                if (this.address !== undefined) writer.writeString(7, this.address);
                if (this.photo !== undefined) writer.writeString(8, this.photo);
                if (this.moodleSuspended !== undefined) writer.writeBool(9, this.moodleSuspended);
                if (this.color !== undefined) writer.writeString(11, this.color);
                if (this.contacts !== undefined) writer.writeRepeatedMessage(10, this.contacts, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IAccount): Uint8Array {
        return (data instanceof Message ? (data as MAccount) : new MAccount(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MAccount {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MAccount();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.firstname = reader.readString();
                    break;
            case 3:
                    message.lastname = reader.readString();
                    break;
            case 4:
                    message.email = reader.readString();
                    break;
            case 5:
                    message.phone = reader.readString();
                    break;
            case 6:
                    message.cellphone = reader.readString();
                    break;
            case 7:
                    message.address = reader.readString();
                    break;
            case 8:
                    message.photo = reader.readString();
                    break;
            case 9:
                    message.moodleSuspended = reader.readBool();
                    break;
            case 11:
                    message.color = reader.readString();
                    break;
            case 10:
                    reader.readMessage(message.contacts, () => Message.addToRepeatedWrapperField(message, 10, dep_2.MUser.deserialize(reader), dep_2.MUser));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MAccount {
        return MAccount.deserializeBinaryFromReader(new MAccount(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MAccount, reader: BinaryReader) {
        return Object.assign(msg, MAccount.deserialize(reader))
    };

}
export interface IPostLogin {
    /**
     * (pattern:email)
     */
    email?: string;
    password?: string;

}
export class PostLogin implements IPostLogin {

    email?: string;
    password?: string;

    constructor(data?: Partial<IPostLogin>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPostLogin extends Message implements PostLogin {

    constructor(data?: Partial<IPostLogin>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("email" in data && data.email != undefined) this.email = data.email;
            if ("password" in data && data.password != undefined) this.password = data.password;
        }
    }

    get email(): string {
        return Message.getField(this, 1) as string;
    }
    set email(value: string) {
        Message.setField(this, 1, value);
    }

    get password(): string {
        return Message.getField(this, 2) as string;
    }
    set password(value: string) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PostLogin() : {} as PostLogin;
        if (this.email != undefined) data.email = this.email;
        if (this.password != undefined) data.password = this.password;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.email !== undefined) writer.writeString(1, this.email);
                if (this.password !== undefined) writer.writeString(2, this.password);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPostLogin): Uint8Array {
        return (data instanceof Message ? (data as MPostLogin) : new MPostLogin(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPostLogin {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPostLogin();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.email = reader.readString();
                    break;
            case 2:
                    message.password = reader.readString();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPostLogin {
        return MPostLogin.deserializeBinaryFromReader(new MPostLogin(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPostLogin, reader: BinaryReader) {
        return Object.assign(msg, MPostLogin.deserialize(reader))
    };

}
export interface IPostChangePassword {
    /**
     * send email if only email value
     */
    email?: string;
    newPassword?: string;
    uid?: string;

}
export class PostChangePassword implements IPostChangePassword {

    email?: string;
    newPassword?: string;
    uid?: string;

    constructor(data?: Partial<IPostChangePassword>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPostChangePassword extends Message implements PostChangePassword {

    constructor(data?: Partial<IPostChangePassword>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("email" in data && data.email != undefined) this.email = data.email;
            if ("newPassword" in data && data.newPassword != undefined) this.newPassword = data.newPassword;
            if ("uid" in data && data.uid != undefined) this.uid = data.uid;
        }
    }

    get email(): string {
        return Message.getField(this, 1) as string;
    }
    set email(value: string) {
        Message.setField(this, 1, value);
    }

    get newPassword(): string {
        return Message.getField(this, 2) as string;
    }
    set newPassword(value: string) {
        Message.setField(this, 2, value);
    }

    get uid(): string {
        return Message.getField(this, 3) as string;
    }
    set uid(value: string) {
        Message.setField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PostChangePassword() : {} as PostChangePassword;
        if (this.email != undefined) data.email = this.email;
        if (this.newPassword != undefined) data.newPassword = this.newPassword;
        if (this.uid != undefined) data.uid = this.uid;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.email !== undefined) writer.writeString(1, this.email);
                if (this.newPassword !== undefined) writer.writeString(2, this.newPassword);
                if (this.uid !== undefined) writer.writeString(3, this.uid);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPostChangePassword): Uint8Array {
        return (data instanceof Message ? (data as MPostChangePassword) : new MPostChangePassword(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPostChangePassword {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPostChangePassword();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.email = reader.readString();
                    break;
            case 2:
                    message.newPassword = reader.readString();
                    break;
            case 3:
                    message.uid = reader.readString();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPostChangePassword {
        return MPostChangePassword.deserializeBinaryFromReader(new MPostChangePassword(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPostChangePassword, reader: BinaryReader) {
        return Object.assign(msg, MPostChangePassword.deserialize(reader))
    };

}
export interface IPostChangeMyPassword {
    currentPassword?: string;
    newPassword?: string;

}
export class PostChangeMyPassword implements IPostChangeMyPassword {

    currentPassword?: string;
    newPassword?: string;

    constructor(data?: Partial<IPostChangeMyPassword>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPostChangeMyPassword extends Message implements PostChangeMyPassword {

    constructor(data?: Partial<IPostChangeMyPassword>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("currentPassword" in data && data.currentPassword != undefined) this.currentPassword = data.currentPassword;
            if ("newPassword" in data && data.newPassword != undefined) this.newPassword = data.newPassword;
        }
    }

    get currentPassword(): string {
        return Message.getField(this, 1) as string;
    }
    set currentPassword(value: string) {
        Message.setField(this, 1, value);
    }

    get newPassword(): string {
        return Message.getField(this, 2) as string;
    }
    set newPassword(value: string) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PostChangeMyPassword() : {} as PostChangeMyPassword;
        if (this.currentPassword != undefined) data.currentPassword = this.currentPassword;
        if (this.newPassword != undefined) data.newPassword = this.newPassword;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.currentPassword !== undefined) writer.writeString(1, this.currentPassword);
                if (this.newPassword !== undefined) writer.writeString(2, this.newPassword);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPostChangeMyPassword): Uint8Array {
        return (data instanceof Message ? (data as MPostChangeMyPassword) : new MPostChangeMyPassword(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPostChangeMyPassword {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPostChangeMyPassword();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.currentPassword = reader.readString();
                    break;
            case 2:
                    message.newPassword = reader.readString();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPostChangeMyPassword {
        return MPostChangeMyPassword.deserializeBinaryFromReader(new MPostChangeMyPassword(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPostChangeMyPassword, reader: BinaryReader) {
        return Object.assign(msg, MPostChangeMyPassword.deserialize(reader))
    };

}
                        




export default () => {}